/* eslint-disable linebreak-style */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/button-has-type */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/prop-types */
import React from 'react';
import { Fade } from 'react-awesome-reveal';
import Button from 'elements/Button';

export default function AllService({ data }) {
  return (
    <Fade bottom>
      <section className="container mx-auto px-4">
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-6 auto-rows-fr">
          {data.map((item, index) => (
            <Fade triggerOnce direction="up" delay={500 * index} key={index}>
              <Button type="link" href={`/service/${item.id}`}>
                <div className="group rounded-2xl shadow-xl w-full m-3 transform transition duration-500 hover:scale-105 flex flex-col h-full">
                  {/* Image */}
                  <div className="relative h-48 overflow-hidden rounded-t-2xl">
                    <img
                      src={item.imageUrl}
                      alt={item.title}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 opacity-0 group-hover:opacity-60 bg-black flex items-center justify-center transition-opacity duration-300 rounded-t-2xl">
                      <svg
                        className="w-20 h-20 text-gray-200"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                        />
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                        />
                      </svg>
                    </div>
                  </div>

                  {/* Title */}
                  <div className="flex-grow flex items-end justify-center px-4 py-5">
                <h2 className="text-theme-blue text-base sm:text-lg md:text-xl text-center font-semibold break-words leading-tight line-clamp-2">
  {item.title}
</h2>
</div>
                </div>
              </Button>
            </Fade>
          ))}
        </div>
      </section>
    </Fade>
  );
}
